
( function () {
   
    'use strict';

    ( function ( $ ) {
        // let items = document.querySelectorAll(".accordion .accordion__item .accordion__item_title");
        // items.forEach(function (t) {
        //     t.addEventListener("click", function (e) {
        //         items.forEach(function (e) {
        //             e !== t || e.classList.parent().contains("open")
        //                 ? e.classList.parent().remove("open")
        //                 : e.classList.parent().add("open");
        //         });
        //     });
        // });
             
        // $('.accordion__item_title').click(function(j) {
    
        //     var dropDown = $(this).closest('.accordion').find('.accordion__item_detail');
        //     $(this).closest('.accordion').find('.accordion__item_detail').not(dropDown).slideUp();
            
        //     if ($(this).hasClass('open')) {
        //       $(this).removeClass('open');
        //     } else {
        //       $(this).closest('.accordion').find('.accordion__item.open').removeClass('open');
        //       $(this).addClass('open');
        //     }
            
        //     dropDown.stop(false, true).slideToggle();
        //     j.preventDefault();
        //   });
    } )( jQuery );
} )();


